module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "excelEr-area"
  }, [_c('el-dialog', {
    attrs: {
      "visible": _vm.dialogVisible,
      "width": "45%"
    },
    on: {
      "update:visible": function($event) {
        _vm.dialogVisible = $event
      }
    }
  }, [_c('div', {
    staticClass: "dialog-area"
  }, [_c('el-scrollbar', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('el-table', {
    ref: "exStrees",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.compData
    },
    on: {
      "row-click": _vm.lineCtrls
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "expand"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-form', {
          staticClass: "demo-table-expand",
          attrs: {
            "label-position": "left",
            "inline": ""
          }
        }, [_vm._l((_vm.thead2), function(term) {
          return [_c('el-form-item', {
            attrs: {
              "label": term.name
            }
          }, [_c('span', {
            class: {
              active: _vm.errorRed(props.row, term.dataName, term)
            }
          }, [_vm._v(_vm._s(_vm._f("formateData")(props.row, term.dataName)))])])]
        })], 2)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "导入错误信息列表",
      "prop": "readCode"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary",
      "size": "small"
    },
    on: {
      "click": function($event) {
        _vm.dialogVisible = false
      }
    }
  }, [_vm._v("确 定")])], 1)], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@12.1.0@vue-loader/lib/template-compiler?{"id":"data-v-4619d8e6"}!./~/_vue-loader@12.1.0@vue-loader/lib/selector.js?type=template&index=0!./src/views/components/excelRead/excelError.vue
// module id = 1473
// module chunks = 1